
import { defineComponent, PropType, computed, getCurrentInstance, ref, onMounted } from 'vue'
import config from '@root/config'
import { checkIntegrationInstalled } from '@/api/marketplace'
const BANNERS = {
    intensive: {
        theme: 't-ink',
        motif: 'slash' as const,
        icon: '🔥',
        badge: 'Маркетплейс',
        title: 'Перезапись можно поднять — это техника, а не везение',
        description:
            'Интенсив по продажам для администраторов: отработка возражений и техники перезаписи в день визита.',
        ctaLabel: 'Узнать подробнее',
        marketplaceId: config.marketplaceModulesIds[config.buildType].salesTraining,
    },
    autopilot: {
        theme: 't-light',
        motif: 'rings' as const,
        icon: '🚀',
        badge: 'Маркетплейс',
        title: 'Бьюти-автопилот: администраторы работают — вы контролируете',
        description:
            'Авто-задачи на перезапись, мотивация за результат и отслеживание прямо в Data Heroes.',
        ctaLabel: 'Узнать подробнее',
        marketplaceId: config.marketplaceModulesIds[config.buildType].beautyAutopilot,
    },
} as const

type BannerVariant = keyof typeof BANNERS

export default defineComponent({
    name: 'SameDayRecPromoBanner',
    props: {
        variant: {
            type: String as PropType<BannerVariant>,
            required: true,
        },
        projectId: {
            type: String,
            required: true,
        },
    },
    setup(props) {
        const root = getCurrentInstance()?.proxy
        const bannerConfig = computed(() => BANNERS[props.variant])
        const isVisible = ref(false)

        onMounted(async () => {
            const marketplaceId = bannerConfig.value.marketplaceId
            if (!props.projectId || !marketplaceId) return

            const isInstalled = await checkIntegrationInstalled(props.projectId, marketplaceId)
            isVisible.value = !isInstalled
        })

        function onCtaClick(config) {
            if (!props.projectId || !config.marketplaceId || !root) return
            const targetPath = `/project/${props.projectId}/marketplace/integration/${config.marketplaceId}`
            const { href } = root.$router.resolve(targetPath)
            window.open(href, '_blank', 'noopener,noreferrer')
        }

        return { config: bannerConfig, isVisible, onCtaClick: () => onCtaClick(bannerConfig.value) }
    },
})
